export enum ActionTypes {
  SET = "@escola/SET",
}
